import React, { useEffect, useRef } from "react";

export default function Reveal({ children, as: Tag = "div", delay = 0, className = "", once = true }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          setTimeout(() => e.target.classList.add("in"), delay);
          if (once) io.unobserve(e.target);
        } else if (!once) {
          e.target.classList.remove("in");
        }
      });
    }, { threshold: 0.14, rootMargin: "0px 0px -60px 0px" });
    io.observe(el);
    return () => io.disconnect();
  }, [delay, once]);
  return <Tag ref={ref} className={`reveal ${className}`}>{children}</Tag>;
}

export function SplitWords({ text, className = "", stagger = 40 }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          const words = el.querySelectorAll(".word");
          words.forEach((w, i) => setTimeout(() => w.classList.add("in"), i * stagger));
          io.unobserve(el);
        }
      });
    }, { threshold: 0.2 });
    io.observe(el);
    return () => io.disconnect();
  }, [stagger]);
  const parts = text.split(" ");
  return (
    <span ref={ref} className={className}>
      {parts.map((p, i) => (
        <span key={i} className="word" style={{ marginRight: "0.28em" }}>
          <span dangerouslySetInnerHTML={{ __html: p }} />
        </span>
      ))}
    </span>
  );
}
